module.exports = __webpack_public_path__ + "img/CJ_01.dd4e6443.webp";